export default "__VITE_ASSET__b00ef3ef__"